import { combineReducers } from 'redux';

import data from './data';
import ui from './ui';

/**
 * @typedef {{
 *   data: import('./data').CampaignFilesDataEntity,
 *   ui: import("./ui").CampaignFilesUIReducer,
 * }} CampaignReducer
 */

export default combineReducers({
  data,
  ui
});
